import styled from 'styled-components';
import {Icon} from 'antd';

import 'antd/lib/spin/style';
import 'antd/lib/icon/style';

export const SpinnerIcon = styled(Icon)`
    font-size: 24px;
`;
